import { createFileRoute } from '@tanstack/react-router'
import { Affiliates } from '@/features/affiliates'

export const Route = createFileRoute('/_authenticated/affiliates/')({
  component: Affiliates,
})
